import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFastForward$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFastForward extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2a2b379c9387fe4a56348b0b5813eaa665960633', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2454a5cecd3359a4107d9dc2e0f42e3ced719bbc', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e02d9800c39aa3bbd5f5ea9e3154180111b503f5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.5 5.48A.5.5 0 0 0 10 6v4.49L3.72 5.54a.46.46 0 0 0-.22-.06A.5.5 0 0 0 3 6v10a.5.5 0 0 0 .5.5.6.6 0 0 0 .22 0L10 11.53V16a.5.5 0 0 0 .5.5.6.6 0 0 0 .22 0L17 11.53v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v4l-6.28-4.99a.46.46 0 0 0-.22-.06", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-fast-forward", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-fast-forward"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-fast-forward":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFastForward$1);
            }
            break;
    } });
}

const CosmosIconFastForward = CosmosIconFastForward$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFastForward, defineCustomElement };
